import { useTranslation } from "react-i18next";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Shell } from "@/components/Shell";

/**
 * Caddy answers every navigation with index.html (ADR-0005), so an unknown path reaches the
 * router rather than a 404 page. Without this it would reach the router's default string.
 */
export function NotFound() {
  const { t } = useTranslation(["account", "common"]);

  return (
    <Shell>
      <Card>
        <CardHeader>
          <CardTitle>{t("notFound.title")}</CardTitle>
          <CardDescription>
            {t("notFound.description")}{" "}
            <a className="jb-link" href="/">
              {t("common:actions.backToStart")}
            </a>
          </CardDescription>
        </CardHeader>
      </Card>
    </Shell>
  );
}
